//系统有单独登录页时使用该配置
const platInfo = {
  platKey: process.env.VUE_APP_KEY,
  platPath: "",
};
//系统无单独登录页，由统一门户入口进入时使用该配置
// const platInfo = {
//   platKey: "portal",
//   platPath: "/portal_web/",
// };
export default platInfo;
